import agent from "agent";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FAVORITE, FAVORITE_PAGE_UNLOADED,MUSIC_SEARCH_LABEL_LOAD_All } from "constants/actionTypes";

import FavoriteTable from "components/Music/comps/FavoriteTable";
import Loading from "components/Loading";
import Avatar from "components/Avatar";
import { redirectTo } from "dispatch";
import "./Favorite.less";

const mapStateToProps = state => ({
    ...state.user,
    ...state.favorite,
    userLogin: state.app.userLogin,
});

const mapDispatchToProps = dispatch => ({
    loadFavorite: (pager, payload) => {
        return dispatch({
            type: FAVORITE,
            pager,
            payload,
        });
    },
    unloadFavorite: () => {
        return dispatch({ type: FAVORITE_PAGE_UNLOADED });
    },
    loadLabelAll: () => {
        return dispatch({
            type: MUSIC_SEARCH_LABEL_LOAD_All,
            payload: agent.Music.searchLabelAlls(),
        });
    },
});

class MyFavorite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            folders: this.readFolders(),
            activeFolder: null,
            folderName: "",
        };
    }
    readFolders = () => [];
    createFolder = e => {
        e.preventDefault();
        const name = this.state.folderName.trim();
        if (!name) return;
        agent.FavoriteFolder.create(name).then(() => agent.FavoriteFolder.load()).then(res => {
            const payload = res.body || res;
            const folders = payload.folders || (payload.data && payload.data.folders) || [];
            this.setState({
                folders: folders.map(folder => ({
                    ...folder,
                    audioIds: folder.audio_ids ? String(folder.audio_ids).split(",") : [],
                })),
                folderName: "",
            });
        }).catch(error => console.log("创建收藏文件夹失败", error));
    };
    deleteFolder = folder => {
        const confirmed = window.confirm(`是否确认删除 ${folder.name}文件夹？\n请注意，文件夹内的所有音乐将会被一起删除。`);
        if (!confirmed) return;
        return agent.FavoriteFolder.delete(folder.id).then(() => this.setState(state => ({ folders: state.folders.filter(item => item.id !== folder.id) })));
    };
    renameFolder = folder => {
        const name = window.prompt("请输入新的文件夹名称", folder.name);
        if (!name || !name.trim()) return;
        agent.FavoriteFolder.rename(folder.id, name.trim()).then(() => this.setState(state => ({ folders: state.folders.map(item => item.id === folder.id ? { ...item, name: name.trim() } : item) })));
    };
    handleFolderDrop = (folder, e) => {
        e.preventDefault();
        const audioId = e.dataTransfer.getData("text/audio-id");
        if (!audioId) return;
        agent.FavoriteFolder.addAudio(folder.id, audioId).then(() => this.setState(state => ({ folders: state.folders.map(item => item.id === folder.id && !item.audioIds.includes(audioId) ? { ...item, audioIds: item.audioIds.concat(audioId) } : item) })));
    };
    static propTypes = {
        currentUser: PropTypes.object,
        loadFavorite: PropTypes.func.isRequired,
        unloadFavorite: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        userLogin: PropTypes.bool.isRequired,
        loading: PropTypes.bool.isRequired,
        total: PropTypes.number.isRequired,
        loadLabelAll:PropTypes.func.isRequired,
    };

    componentWillUnmount() {
        this.props.unloadFavorite();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!nextProps.currentUser) {
            // login first
            redirectTo("/login");
            return false;
        }
        return true;
    }

    componentDidMount() {
        const { userLogin } = this.props;
        if (!userLogin) {
            // login first
            redirectTo("/login");
            return false;
        }
        this.props.loadLabelAll();
        agent.FavoriteFolder.load().then(res => {
            const folders = (res.body || res).folders;
            if (folders) this.setState({ folders: folders.map(folder => ({ ...folder, audioIds: folder.audio_ids ? String(folder.audio_ids).split(",") : [] })) });
        }).catch(() => {});
    }

    loadData(pager, params) {
        const { loadFavorite } = this.props;
        loadFavorite(pager, agent.Favorite.load(params));
    }
    back(e){
        redirectTo("/user/mypage");
    }
    render() {
        const { location, match, currentUser, total, loading } = this.props;
        if (!currentUser) {
            return null;
        }
        return (
            <div className="mypageContents" id ="myfavorite">
                <div className="mypageContents__inner2">
                    <header className="mainHeading">
                        <h1 className="mainHeading__title">喜爱列表</h1>
                    </header>
                    <div className="mainContents__box myloveBox">
                        <div className="myloveBox__inner">
                            <div className="avatarBox hidden">
                                <div className="avatarBox__img">
                                    <Avatar
                                        src={agent.getApiUrl(
                                            currentUser.avatar
                                        )}
                                        alt=""
                                    />
                                </div>
                                <p className="avatarBox__name">
                                    {currentUser.nickname}
                                </p>
                            </div>
                            <div className="resultContents">
                                <Loading loading={loading} />
                                <p className="resultTxt">
                                    您已经关注了
                                    <span>{total}</span>
                                    首音乐
                                    <button onClick={this.back.bind(this)} className='backHome'>返回</button>
                                </p>
                                <section className="favoriteFolders" aria-label="收藏文件夹">
                                    <div className="favoriteFolders__header">我的文件夹</div>
                                    <form onSubmit={this.createFolder} className="favoriteFolders__create">
                                        <input value={this.state.folderName} onChange={e => this.setState({ folderName: e.target.value })} placeholder="新建文件夹名称" />
                                        <button type="submit">创建</button>
                                    </form>
                                    <div className="favoriteFolders__list">
                                        <button className={!this.state.activeFolder ? "is-active" : ""} onClick={() => this.setState({ activeFolder: null })}>全部收藏</button>
                                        {this.state.folders.map(folder => (
                                            <div key={folder.id} className="favoriteFolder" onDragOver={e => e.preventDefault()} onDrop={this.handleFolderDrop.bind(this, folder)}>
                                                <button className={this.state.activeFolder === folder.id ? "is-active" : ""} onClick={() => this.setState({ activeFolder: folder.id })}>{folder.name}</button>
                                                <small>{folder.audioIds.length} 首</small>
                                                <button type="button" onClick={() => this.renameFolder(folder)} aria-label={`重命名${folder.name}`}>改名</button>
                                                <button type="button" onClick={() => this.deleteFolder(folder)} aria-label={`删除${folder.name}`}>×</button>
                                            </div>
                                        ))}
                                    </div>
                                    <p className="favoriteFolders__hint">可将音乐拖拽到文件夹中整理</p>
                                </section>
                             
                                <FavoriteTable
                                    loadData={this.loadData.bind(this)}
                                    location={location}
                                    match={match}
                                    filterAudioIds={this.state.activeFolder
                                        ? ((this.state.folders.find(folder => folder.id === this.state.activeFolder) || {}).audioIds || [])
                                        : null}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyFavorite);
